/**
 * 闪烁动画
 */
import fvAnimation from "./fvAnimation"
export default class fvTwinkel extends fvAnimation {
    constructor(shape){
        super(shape,"fvTwinkel");
        //为了让run顺序执行，提前准备好所需数据、方法、属性等

        //表达式
        this.excExpression = AsyncFunction("return " + this.expression);;
        //动画模板函数
        // this.runAnimation(canvas) = this.model == "c" ?this.twinkle: this.fade;
        //动画刷新间隔
        this.nTickCount = Date.now();
        //保存原始shape 的填充、边线颜色
        this.shape.initFcHide = this.shape.fcHide;
        this.oldColor = this.shape.outsideColor;
        this.shape.colorOldFillColor = this.shape.color;
        this.shape.colorOldBorderColor = this.shape.borderColor;
        //智能单元初始化所有图元赋值
        this.initIsSubObjects(this.shape);
        this.count;
        if(this.speed == 0){
            this.count = 3000;
        }else if(this.speed == 1){
            this.count = 1500;
        }else{
            this.count = 1000;
        }
        // 图元闪烁或者显隐 表达式false重置。
        this.flag = true;
    }

    //初始化定义color和borderColor
    initIsSubObjects(shape){
        if(shape.fctype == "fvGroupObj" && shape.subObjects){
            for (var p in shape.subObjects) {
                try {
                    if(p == "$"){
                        continue;
                    }
                    if(shape.subObjects[p].$.fctype == "fvGroupObj" && shape.subObjects){
                        this.initIsSubObjects(shape.subObjects[p].$);
                    }else{
                        shape.subObjects[p].$.colorOldFillColor = shape.subObjects[p].$.color;
                        shape.subObjects[p].$.colorOldBorderColor = shape.subObjects[p].$.borderColor;
                    }
                }catch(error){
                    console.log(error);
                }
            }
        }
    }
    runAnimationALl(svgDom){
        if(this.model == "c"){
            this.twinkle(svgDom)
        }else{
            this.fade();
        }
    }
    async run(svgDom,value){
        if(value == false) return;
       var size = await this.executionScript(this.excExpression);
        var nowTime = Date.now();
        if(nowTime - this.nTickCount >= this.count){
            //大于间隔处理才处理动画逻辑
            this.nTickCount = nowTime;
            this.flag = false;
            if(size){
                this.flag = false;
                this.runAnimationALl(svgDom);
            }else{
                this.flag = true;
                this.runAnimationALl(svgDom);
            }
            super.run();
        }
    }
    twinkle(divDom){
        // this.isSubObjectsTwinkle(this.shape);
        this.animationExecutionTwinkle(this.shape,divDom);
    }
    //递归调用每一层图元
    // isSubObjectsTwinkle(shape){
    //     if(shape.fctype == "fvGroupObj" && shape.subObjects){
    //         for (var p in shape.subObjects) {
    //             try {
    //                 if(p == "$"){
    //                     continue;
    //                 }
    //                 if(shape.subObjects[p].$.fctype == "fvGroupObj" && shape.subObjects){
    //                     this.isSubObjectsTwinkle(shape.subObjects[p].$);
    //                 }else{
    //                     this.animationExecutionTwinkle(shape.subObjects[p].$);
    //                 }
    //             }catch(error){
    //                 console.log(error);
    //             }
    //         }
    //         return false;
    //     }
    // }
    //闪烁动画执行
    animationExecutionTwinkle(shape,divDom){
        //管道颜色
        if(shape.fctype == "fvPipeObj"){
            if(this.flag){
                shape.color = shape.colorOldBorderColor;
                divDom.style.fill=shape.color;
            }else{
                shape.outsideColor = shape.outsideColor == this.fillColor ? this.oldColor : this.fillColor;
                divDom.style.fill=shape.outsideColor;
            }
        }else if(shape.fctype == "fvTextObj"){
            //文本颜色
            if(this.flag){
                shape.color = shape.colorOldFillColor;
            }else{
                shape.color = shape.color == shape.colorOldFillColor ? this.borderColor : shape.colorOldFillColor;

            }
            divDom.lastElementChild.style.fill=shape.color;
        }else if(shape.fctype == "fvPolylineObj"){
            //多折线
            if(this.flag){
                shape.borderColor = shape.borderColor = shape.colorOldBorderColor;
            }else{
                shape.borderColor = shape.borderColor == shape.colorOldBorderColor ? this.borderColor : shape.colorOldBorderColor;

            }
            divDom.style.stroke=shape.borderColor;
        }else if(shape.fctype==="fvButtonObj"){
            if(this.flag){
                shape.borderColor = shape.borderColor = shape.colorOldBorderColor;
            }else{
                shape.borderColor = shape.borderColor == shape.colorOldBorderColor ? this.fillColor : shape.colorOldBorderColor;
            }
            divDom.parentNode.getElementById(shape.registerName).innerHTML=`
            <stop offset="0" stop-color="rgba(0,0,0,0)" fill-opacity="0">
            </stop><stop offset="0.012" stop-color="${shape.borderColor}" fill-opacity="1">
            </stop><stop offset="1" stop-color="${shape.borderColor}" fill-opacity="1">
            </stop>
            `
            divDom.style.fill=`url(#${shape.registerName})`
        }else{
            if(this.flag){
                shape.color = shape.colorOldFillColor;
                shape.borderColor = shape.colorOldBorderColor;
                divDom.style.fill=shape.color;
                divDom.style.stroke=shape.borderColor;
            }else{
                //  填充颜色
                //  判断当前颜色是否转为rgba，因为在椭圆矩形中存在rgba颜色转换
                if(shape.color.toLowerCase().indexOf("rgba")>-1){
                    var rgbArray = shape.colorOldFillColor.colorRgb(shape.opacity/255).toLowerCase();
                    shape.color =  shape.color.toLowerCase() == rgbArray ?  this.fillColor : rgbArray;
                }else{
                    shape.color = shape.color == shape.colorOldFillColor ? this.fillColor : shape.colorOldFillColor;
                }
                //边框颜色
                shape.borderColor = shape.borderColor == shape.colorOldBorderColor ? this.borderColor : shape.colorOldBorderColor;
                divDom.style.fill=shape.color;
                divDom.style.stroke=shape.borderColor;
            }
        }
    }

    fade(){
        // this.isSubObjectsFade(this.shape);
       this.animationExecutionFade(this.shape);
    }
    //递归调用每一层图元
    // isSubObjectsFade(shape){
    //     if(shape.fctype == "fvGroupObj" && shape.subObjects){
    //         for (var p in shape.subObjects) {
    //             try {
    //                 if(p == "$"){
    //                     continue;
    //                 }
    //                 if(shape.subObjects[p].$.fctype == "fvGroupObj" && shape.subObjects){
    //                     this.isSubObjectsFade(shape.subObjects[p].$);
    //                 }else{
    //                     this.animationExecutionFade(shape.subObjects[p].$);
    //                 }
    //             }catch(error){
    //                 console.log(error);
    //             }
    //         }
    //         return false;
    //     }
    // }
    //显隐动画执行
    animationExecutionFade(shape){
        if(this.flag){
           shape.Show(shape.initFcHide, 'animation');
            
        }else{
           shape.Show(shape.fcHide, 'animation');
            shape.fcHide=!shape.fcHide;
           
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvTwinkel.js